module.exports = __webpack_public_path__ + "static/img/Addin-Fonua-Blake.308aa7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Addin-Fonua-Blake.jpg
// module id = qW0R
// module chunks = 0